var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"DashboardView"},[_c('DashboardTopBar',{staticClass:"header",attrs:{"can-show-upgrade":_vm.$route.meta.canShowUpgrade}}),_c('router-view',{key:_vm.$route.path,staticClass:"body"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }